import { render, staticRenderFns } from "./SolicitudPage.vue?vue&type=template&id=c1f9124c&"
import script from "./SolicitudPage.vue?vue&type=script&lang=js&"
export * from "./SolicitudPage.vue?vue&type=script&lang=js&"
import style0 from "./SolicitudPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports